import type { StaticDataRouteOption } from "@tanstack/react-router"

import { SettingsNavigation } from "../SettingsNavigation/SettingsNavigation"
import { IssueTypeSettingsAttachmentsViewTopBar } from "./TopBar"

export const issueTypeAttachmentsViewStaticData: StaticDataRouteOption = {
	leftSlideOut: SettingsNavigation,
	topBar: IssueTypeSettingsAttachmentsViewTopBar,
}
